module.exports = __webpack_public_path__ + "static/media/resize.80177305.svg";